import { ElementInstance, Page, SectionRef, Space } from '../model';

export type SelectionState = Readonly<
  | {
      nodeId?: string;
      element: ElementInstance;
      section: SectionRef;
      page: Page;
      space: Space | 'home';
      addDirection?: 'before' | 'after';
    }
  | {
      nodeId?: undefined;
      element?: undefined;
      section: SectionRef;
      page: Page;
      space: Space | 'home';
    }
  | {
      nodeId?: undefined;
      element?: undefined;
      section?: undefined;
      page: Page;
      space: Space | 'home';
    }
  | {
      nodeId?: undefined;
      element?: undefined;
      section?: undefined;
      page?: undefined;
      space: Space | 'home';
    }
  | {
      nodeId?: undefined;
      element?: undefined;
      section?: undefined;
      page?: undefined;
      space?: undefined;
    }
>;

export function statesEqual(sel: SelectionState, other: SelectionState) {
  return idForSelectionState(sel) === idForSelectionState(other);
}

export function idForSelectionState(state: SelectionState) {
  if (state.element) {
    // An element might be in multiple sections (if it is a global)
    return `${state.section.oid}:${state.element.oid}:${state.nodeId}`;
  } else if (state.section) {
    return state.section.oid;
  } else if (state.page) {
    return state.page.oid;
  } else if (state.space === 'home') {
    return 'home';
  } else if (state.space) {
    return state.space.oid;
  } else {
    return 'idOfEmptySelection';
  }
}
